import { hideDialog } from "fe2/Actions/ActionDialog";
import { connect } from "react-redux";
import MonumentAchievementsDialog from "~/Components/UIKit/MonumentAchievementsDialog/MonumentAchievementsDialog";

const mapStateToProps = (state, ownProps) => {
  return {
    achievements: state.clans.achievements[ownProps.clanId],
    tag: state.clans.items[ownProps.clanId].tag,
    color: state.clans.items[ownProps.clanId].color
  };
};

const mapDispatchToProps = dispatch => ({
  hideDialog: () => dispatch(hideDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(MonumentAchievementsDialog);